// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingPage_loading__MuTf_"};